<template>
  <div class="overflow-y-hidden ">
    <template-american v-if="getGameConsole === 'american'"/>
    <template-terminal v-else-if="getGameConsole === 'terminal'"/>
    <template-market-view v-else/>



  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { isMobileOnly, isTablet } from 'mobile-device-detect'



import TemplateAmerican from "@/views/TemplateAmerican.vue";
import TemplateMarketView from "@/views/TemplateMarketView.vue";
import TemplateTerminal from "@/views/TemplateTerminal.vue";


export default {
  name: 'BetConsole',

  components: {
    TemplateMarketView,
    TemplateAmerican,
    TemplateTerminal
  },

  data: () => ({
  }),

  computed: {
    ...mapGetters({
      'getGameConsole':            'settings/getGameConsole',
    })
  },

  watch: {

  },



  onActive() {},
}
</script>

<style scoped>

/* ── Root container: max-width centrato ─────────────────────────────────────── */
.betconsole-root {
  max-width: 1920px;
  margin: 0 auto!important;
}

.betconsole-root.american{
  max-width: 1450px!important;
}

/* ── Desktop 3-column flex layout ───────────────────────────────────────────── */
.bc-layout {
  display: flex;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  align-items: stretch;
}

.bc-col-left,
.bc-col-right {
  flex: 0 0 clamp(200px, 320px, 320px);
  width: clamp(200px, 320px, 320px);
  min-width: 0;
  overflow: hidden;
}

.american .bc-col-left,
.american .bc-col-right {
  flex: 0 0 clamp(200px, 270px, 320px);
  width: clamp(200px, 270px, 320px);
  min-width: 0;
  overflow: hidden;
}

.american .bc-col-left{
  border-right: 1px solid var(--hsla-1);
}

.bc-col-center {
  flex: 1 1 0;
  min-width: 0;
  overflow: hidden;
}

/* At large screens lock to exact design width */
@media (min-width: 1500px) {
  .bc-col-left,
  .bc-col-right { flex-basis: 320px; width: 320px; }

  .american .bc-col-left,
  .american .bc-col-right { flex-basis: 270px; width: 270px; }
}

/* At smaller desktop screens shrink side columns further */
@media (max-width: 1024px) {
  .bc-col-left,
  .bc-col-right { flex-basis: clamp(160px, 18vw, 240px); width: clamp(160px, 18vw, 240px); }
}

/* ── Idle toast ─────────────────────────────────────────────────────────────── */
.idle-overlay {
  position: fixed;
  inset: 0;
  z-index: 9998;
  background: rgba(0, 0, 0, 0.55);
}
.idle-toast {
  position: fixed;
  z-index: 9999;
  display: flex;
  align-items: center;
  gap: 12px;
  background: var(--bg-secondary, #1e1e2e);
  border: 1px solid var(--color-primary, #a37e2c);
  border-radius: 8px;
  padding: 12px 16px!important;
  box-shadow: 0 4px 20px rgba(0,0,0,0.5);
  max-width: 360px;
}
.idle-toast--desktop {
  bottom: 16px;
  right: 16px;
}
.idle-toast--mobile {
  bottom: 10px;
  left: 6px;
  right: 6px;
  max-width: 100%;
  border-radius: 8px;
}
.idle-toast__body {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  flex: 1;
  min-width: 0;
}
.idle-toast__icon {
  font-size: var(--font-size-8xl);
  flex-shrink: 0;
}
.idle-toast__text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: var(--font-size-3xl);
  color: var(--text-platform, #e0e0e0);
}
.idle-toast__text strong {
  font-size: var(--font-size-3xl);
  font-weight: 700;
  color: var(--color-primary, #a37e2c);
}
.idle-toast__btn {
  flex-shrink: 0;
  background: var(--color-primary, #a37e2c);
  color: #fff;
  border: none;
  border-radius: 5px;
  padding: 7px 16px;
  font-size: var(--font-size-3xl);
  font-weight: 700;
  cursor: pointer;
  transition: opacity 0.15s;
}
.idle-toast__btn:hover { opacity: 0.85; }
.idle-toast-fade-enter-active, .idle-toast-fade-leave-active { transition: opacity 0.3s, transform 0.3s; }
.idle-toast-fade-enter, .idle-toast-fade-leave-to { opacity: 0; transform: translateY(12px); }
/* ────────────────────────────────────────────────────────────────────────────── */

div.v-overlay.v-overlay--active.theme--dark > div.v-overlay__scrim {
  opacity: 0.86 !important;
}

/* ── Layout a 3 colonne con scroll indipendente ── */
.col-scroll {
  height: 100vh;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.col-scroll::-webkit-scrollbar { display: none; }

#leftModuleV2Container {
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
#leftModuleV2Container::-webkit-scrollbar { display: none; }

/* ── View mode trigger button (mobile only) ───────────────────── */
.vmt-trigger-wrap {
  display: none;
}
@media (max-width: 600px) {
  .container_search_settings{
    padding: 10px 10px 0;
  }

  .vmt-trigger-wrap {
    display: flex;
    justify-content: flex-end;
    padding: 0 0 0 8px;
  }
  .vmt-trigger-btn {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--hsla-1);
    cursor: pointer;
    transition: background 0.15s, transform 0.2s;
    touch-action: manipulation;
    flex-shrink: 0;
  }
  .vmt-trigger-btn:active { transform: scale(0.92); }
  .vmt-trigger-btn .v-icon { color: var(--text-platform) !important; font-size: var(--font-size-7xl) !important; }

}

/* ── View mode overlay + modal ───────────────────────────────────── */
.vmt-overlay {
  position: fixed;
  inset: 0;
  z-index: 300;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
.vmt-fade-enter-active, .vmt-fade-leave-active { transition: opacity 0.2s ease; }
.vmt-fade-enter, .vmt-fade-leave-to { opacity: 0; }
.vmt-modal {
  background: var(--bg-body, #1e1e2e);
  border-radius: 16px 16px 0 0;
  padding: 20px 16px 90px;
  width: 100%;
  max-width: 480px;
  max-height: 90vh;
  overflow-y: auto;
}
.vmt-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
}
.vmt-modal-title {
  font-size: var(--font-size-4xl);
  font-weight: 700;
  color: var(--text-platform);
}
.vmt-close-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 2px;
  display: flex;
  align-items: center;
  line-height: 1;
}
.vmt-close-btn .v-icon { color: var(--text-op-50-platform) !important; }
.vmt-modal-desc {
  font-size: var(--font-size-2xl);
  color: var(--text-op-50-platform);
  margin: 0 0 16px;
}
.vmt-options {
  display: flex;
  flex-direction: row;
  gap: 10px;
}
.vmt-option {
  border: 2px solid var(--border-color, #333);
  border-radius: 10px;
  padding: 10px 12px;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s;
  background: var(--bg-card, #1a1a1a);
  display: flex;
  flex-direction: column;
  gap: 10px;
  touch-action: manipulation;
  user-select: none;
  width: 50%;
}
.vmt-option--active {
  border-color: var(--color-primary);
  background: var(--color-primary-op);
}
.vmt-option-label {
  display: flex;
  align-items: center;
  font-size: var(--font-size-md);
  font-weight: 700;
  color: var(--text-platform);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  gap: 3px;
}
.vmt-option-label .v-icon { color: var(--text-platform) !important; }
.vmt-check { color: var(--color-primary, #00c864) !important; }

/* ── Skeleton previews ───────────────────────────────────────────── */
.vmt-preview {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
/* Compact: info left + 3 chips right */
.vmt-sk-row {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 5px 0;
  border-bottom: 1px solid rgba(255,255,255,0.05);
}
.vmt-sk-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.vmt-sk-line {
  height: 6px;
  background: rgba(255,255,255,0.12);
  border-radius: 3px;
}
.vmt-sk-chips {
  display: flex;
  gap: 3px;
  flex-shrink: 0;
}
.vmt-sk-chip {
  width: 22px;
  height: 22px;
  background: rgba(255,255,255,0.09);
  border-radius: 4px;
}
/* Extended: info stacked, then chips full-width below */
.vmt-sk-row-ext {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 6px 0;
  border-bottom: 1px solid rgba(255,255,255,0.05);
}
.vmt-sk-info-ext {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.vmt-sk-chips-ext {
  display: flex;
  gap: 3px;
}
.vmt-sk-chip-wide {
  flex: 1;
  height: 20px;
  background: rgba(255,255,255,0.09);
  border-radius: 4px;
}

@media (max-width: 600px) {
  /* ── Extended event row layout ──────────────────────────────── */
  .event-row--extended .col-info {
    flex-direction: column;
    align-items: stretch;
    height: auto;
    width: 100%;
    border-right: none;
    padding: 6px 10px;
    gap: 0;
  }
  .event-row--extended .meta-block {
    order: -1;
    width: 100%;
    min-width: unset;
    display: flex;
    align-items: center;
    gap: 6px;
    padding-bottom: 5px;
    border-bottom: 1px solid var(--border-color, #333);
    margin-bottom: 5px;
  }
  .event-row--extended .info-market-block {
    display: flex;
    align-items: center;
    gap: 6px;
  }
  .event-row--extended .competitors-block {
    flex-direction: row;
    justify-content: space-between;
    gap: 6px;
    font-size: var(--font-size-3xl);
  }
  .event-row--extended .team-name {
    flex: 1;
    min-width: 0;
  }
  .event-row--extended .team-name.away {
    flex-direction: row-reverse;
    text-align: right;
  }
  .event-row--extended .col-center {
    width: 100%;
    height: auto;
    min-height: 44px;
    border-right: none;
    border-top: 1px solid var(--border-color, #333);
  }
  .event-row--extended .col-more {
    display: none;
  }
}

/* ── Modal settings section ──────────────────────────────────────── */
.vmt-settings-divider {
  height: 1px;
  background: var(--border-color, #333);
  margin: 14px 0 12px;
}
.vmt-settings {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.vmt-setting-row {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}
.vmt-setting-label {
  font-size: var(--font-size-2xl);
  font-weight: 500;
  color: var(--text-op-50-platform);
}

/* Odds type accordion */
.vmt-accordion {
  width: 100%;
}
.vmt-accordion-trigger {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 10px;
  background: var(--bg-card, #222);
  border: 1px solid var(--border-color, #333);
  border-radius: 6px;
  color: var(--text-platform);
  font-size: var(--font-size-2xl);
  font-weight: 600;
  cursor: pointer;
  transition: border-color 0.15s;
}
.vmt-accordion-trigger--open {
  border-color: var(--color-primary, #00c864);
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.vmt-acc-chevron {
  transition: transform 0.2s;
  color: var(--text-op-50-platform);
  flex-shrink: 0;
}
.vmt-accordion-trigger--open .vmt-acc-chevron {
  transform: rotate(180deg);
}
.vmt-accordion-list {
  border: 1px solid var(--color-primary, #00c864);
  border-top: none;
  border-radius: 0 0 6px 6px;
  overflow: hidden;
}
.vmt-accordion-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 10px;
  font-size: var(--font-size-2xl);
  color: var(--text-op-50-platform);
  cursor: pointer;
  transition: background 0.12s;
  background: var(--bg-card, #222);
}
.vmt-accordion-item + .vmt-accordion-item {
  border-top: 1px solid rgba(255,255,255,0.05);
}
.vmt-accordion-item:hover {
  background: var(--bg-card-hover, #2a2a2a);
  color: var(--text-platform);
}
.vmt-accordion-item--active {
  color: var(--text-platform);
  font-weight: 600;
}
.vmt-acc-check {
  color: var(--color-primary, #00c864) !important;
  flex-shrink: 0;
}

/* Toggle switch */
.vmt-switch {
  position: relative;
  width: 34px;
  height: 18px;
  flex-shrink: 0;
  cursor: pointer;
}
.vmt-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.vmt-slider {
  position: absolute;
  inset: 0;
  background: #444;
  border-radius: 20px;
  transition: 0.2s;
  cursor: pointer;
}
.vmt-slider::before {
  content: '';
  position: absolute;
  height: 12px;
  width: 12px;
  left: 3px;
  bottom: 3px;
  background: #fff;
  border-radius: 50%;
  transition: 0.2s;
}
.vmt-switch input:checked + .vmt-slider {
  background: var(--color-accent, #00c864);
}
.vmt-switch input:checked + .vmt-slider::before {
  transform: translateX(16px);
}

.container_search_settings{
  display: flex;
}

/* ── Mobile sticky fix ──────────────────────────────────────────────────────────
   overflow-y: hidden on a non-scrolling ancestor breaks position: sticky — the
   browser treats that ancestor as the sticky scroll container but it never scrolls,
   so sticky elements never activate. On mobile the window is the scroll context, so
   we reset overflow-y to visible for this root AND for TemplateAmerican's root
   (Vue 2 scoped CSS applies to direct child components' root elements too).
   Desktop is unaffected: the 3-column .col-scroll.center (overflow-y: auto)
   remains the sticky scroll container for the center column.              ─────── */
@media (max-width: 1199px) {
  .overflow-y-hidden {
    overflow-y: visible !important;
  }
}

</style>
